import * as yup from "yup";
import { TFunction } from "i18next";

export const cameraAddValidation = (t: TFunction) =>
  yup.object().shape({
    // Text inputs
    ...["name", "cameraUrl"].reduce(
      (acc, el) => ({
        ...acc,
        [el]: yup
          .string()
          .required(t("validation.required"))
          .max(250, t("validation.more250")),
      }),
      {}
    ),

    // Select inputs
    ...["cameraZoneId"]
      .filter((el) => !!el)
      .reduce(
        (acc, el) => ({
          ...acc,
          [el]: yup.object().shape({
            value: yup
              .string()
              .nullable()
              .required(t("validation.required"))
              .matches(/^((?!Не выбрано|Not chosen).)*$/g),
          }),
        }),
        {}
      ),

    // Special check
    ...["cameraUrl"].reduce(
      (acc, el) => ({
        ...acc,
        [el]: yup
          .string()
          .required(t("validation.required"))
          .matches(
            /^rtsp:\/\/|http[s]?:\/\//,
            t("cameraView.RTSPFormatNotMatch")
          )
          .max(250, t("validation.more250")),
      }),
      {}
    ),
  });
